import {useCart} from '@shopify/hydrogen';
import CircleOutlineButton from '../elements/CircleOutlineButton';
import {useCartUI} from './CartUIProvider.client';

type Props = {
  onClick?: () => void;
};

/**
 * A client component that defines the behavior when a user toggles a cart
 */
export default function CartToggle({onClick}: Props) {
  const {totalQuantity} = useCart();
  const {isCartOpen, toggleCart} = useCartUI();

  return (
    <div className="relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pb-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
        >
          <path d="M20 7h-4v-3c0-2.209-1.791-4-4-4s-4 1.791-4 4v3h-4l-2 17h20l-2-17zm-11-3c0-1.654 1.346-3 3-3s3 1.346 3 3v3h-6v-3zm-4.751 18l1.529-13h2.222v1.5c0 .276.224.5.5.5s.5-.224.5-.5v-1.5h6v1.5c0 .276.224.5.5.5s.5-.224.5-.5v-1.5h2.222l1.529 13h-15.502z" />
        </svg>
      </div>
      <div className="relative z-1 translate-y-[2px]">
        <CircleOutlineButton
          className="border-none text-[10px]"
          aria-expanded={isCartOpen}
          aria-controls="cart"
          onClick={() => {
            toggleCart();
            onClick?.();
          }}
        >
          {totalQuantity}
        </CircleOutlineButton>
      </div>
    </div>
  );
}
